/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { groupAlternativesByEnunciado } from '../utils/groupAlternativesByEnunciado';

export default function AllQuestionGradeTable({
  dataToShow,
  headerHeight,
  mainAlternatives,
  columnLabelKey,
}) {

  /**
   * Renderiza a linha de título da pergunta cruzada
   */
  function renderCrossQuestionColumns(pergunta) {
    return (
      <tr>
        <th
          colSpan={dataToShow.perguntas_principais[0].alternativas.length + 4}
          style={{ top: headerHeight }}
          className="questionTitle"
        >
          <span className="pergunta-cruzada-wrapper">{pergunta.enunciado}</span>
        </th>
      </tr>
    );
  }

  /**
   * Renderiza a linha cinza contendo os títulos das colunas da grade (alternativas principais)
   */
  function renderMainQuestionRows() {
    return (
      <tr>
        <td className="grade-lines"></td>
        <td className="grade-lines" colSpan="2"></td>
        {mainAlternatives.map((alternativa) => (
          <td key={alternativa.id} className="pergunta-cruzada-wrapper grade-lines">
            {alternativa[columnLabelKey]}
          </td>
        ))}
      </tr>
    );
  }

  /**
   * Renderiza os grupos de alternativas cruzadas, agrupadas por enunciado
   */
  function renderGroupedAlternatives(pergunta) {
    const grouped = groupAlternativesByEnunciado(pergunta.alternativas);
    return Object.entries(grouped).map(([enunciado, alternativas]) => (
      <React.Fragment key={enunciado}>
        {/* Linha de separação por grupo da pergunta cruzada */}
        <tr>
          <td className="gradeTitle">{enunciado}</td>
          <td colSpan={dataToShow.perguntas_principais[0].alternativas.length + 3} className="gradeTitle-col"></td>
        </tr>
        {/* Renderiza cada alternativa dentro do grupo */}
        {alternativas.map((alternativa) => renderAlternativeRow(alternativa))}
      </React.Fragment>
    ));
  }

  /**
   * Renderiza a linha de dados para uma alternativa cruzada
   */
  function renderAlternativeRow(alternativa) {
    return (
      <tr key={alternativa.id}>
        <td className="row">{alternativa.titulo_grade}</td>
        <td className="respondentes resultadoNumerico">
          <span>{alternativa.resultado_numerico}</span>
        </td>
        <td className="respondentes resultadoPercentual">
          {`${alternativa.resultado_percentual}%`}
        </td>
        {renderCrossings(alternativa)}
      </tr>
    );
  }

  /**
   * Renderiza os cruzamentos entre a alternativa cruzada e cada alternativa principal
   */
  function renderCrossings(alternativa) {
    return mainAlternatives.map((item) => {
      const cruzamento = alternativa.cruzamentos?.[item.id];
      return (
        <td
          key={item.id}
          className={`resultado-cruzamento ${
            cruzamento?.marcacao?.is_checked ? 'selecionado' : ''
          }`}
          title={`Equivale a ${cruzamento?.resultado_numerico || ''} resposta(s)`}
        >
          <span>{`${cruzamento?.resultado_percentual || 0}%`}</span>
        </td>
      );
    });
  }

  /**
   * Renderiza o corpo completo da tabela para cada pergunta cruzada
   */
  return (
    <>
      {dataToShow.perguntas_principais[0].perguntas_cruzadas.map((pergunta) => (
        <tbody key={pergunta.id}>
          {renderCrossQuestionColumns(pergunta)}
          {renderMainQuestionRows()}
          {renderGroupedAlternatives(pergunta)}
        </tbody>
      ))}
    </>
  );
}